package com.neurobs.ccabserver.transcriptreview.states

import com.neurobs.js.view.AudioViewer
import com.neurobs.util.Interval
import com.neurobs.util.TimeSeconds
import com.neurobs.util.TimeSeconds.TimeSecondsInterval
import org.scalajs.dom.AudioBuffer

class AudioViewerSequenceState(buffers: Seq[AudioBuffer], var delegate: AudioViewerSequenceState.Delegate = AudioViewerSequenceState.NullDelegate) {
	import AudioViewerSequenceState._

	val viewers: Vector[ViewerElement] = {
		var offset: TimeSeconds = TimeSeconds(0)
		val s = buffers.zipWithIndex map { e =>
			val temp = offset
			offset = offset + TimeSeconds(e._1.duration)
			ViewerElement(new AudioViewer(e._1, new ViewerDelegate(e._2)), temp)
		}
		s.toVector
	}
	private var currentIndex: Option[Int] = None
	private var playing: Boolean = false

	private def setPlaying(p: Boolean): Unit = {
		//println(s"setPlaying $playing $p")
		if (p != playing) {
			playing = p
			delegate.setPlaying(playing)
		}
	}

	private def handleFinish(index: Int): Unit = {
		val next = index + 1
		if (next < viewers.length) {
			viewers(next).viewer.play(Interval[TimeSeconds](begin = TimeSeconds(0), viewers(next).viewer.duration))
			currentIndex = Some(next)
		}
		else {
			currentIndex = None
			setPlaying(false)
		}
	}

	private def handleClick(index: Int): Unit = {
		//println(s"onClick file $index")
		if (playing && (currentIndex != Some(index))) {
			currentIndex.foreach(viewers(_).viewer.pause())
		}
		currentIndex = Some(index)
		for (i <- Range(0, index)) viewers(i).viewer.setPercentage(1)
		for (i <- Range(index + 1, viewers.length)) viewers(i).viewer.setPercentage(0)
	}

	private class ViewerDelegate(index: Int) extends AudioViewer.Delegate {
		override def onPlay(): Unit = {
			//println("onPlay")
			setPlaying(true)
		}
		override def onPause(): Unit = {
			//println("onPause")
			if (currentIndex == Some(index)) {
				setPlaying(false)
			}
		}
		override def onFinish(): Unit = {
			//println("onFinish")
			handleFinish(index)
		}
		override def onClick(): Unit = handleClick(index)
		override def onAudioProcess(time: TimeSeconds): Unit = {
			//println(s"onAudioProcess $time")
			delegate.onPlaying(recordingIndex = index, time = time)
		}
	}

	def playPause(): Unit = {
		//println("AudioViewerSequenceState.playPause")
		if (viewers.nonEmpty) {
			currentIndex match {
				case None =>
					//println("AudioViewerSequenceState.playPause currentIndex = None")
					currentIndex = Some(0)
					viewers(0).viewer.playPause()
				case Some(i) =>
					//println(s"AudioViewerSequenceState.playPause currentIndex = $i")
					viewers(i).viewer.playPause()
			}
		}
	}

	def play(index: Int, interval: TimeSecondsInterval): Unit = {
		if (index < viewers.length) {
			currentIndex.foreach(viewers(_).viewer.pause())
			viewers(index).viewer.play(interval)
			currentIndex = Some(index)
		}
	}
}

object AudioViewerSequenceState {
	trait Delegate {
		def setPlaying(playing: Boolean): Unit
		def onPlaying(recordingIndex: Int, time: TimeSeconds)
	}

	object NullDelegate extends Delegate {
		override def setPlaying(playing: Boolean): Unit = {}
		override def onPlaying(recordingIndex: Int, time: TimeSeconds): Unit = {}
	}

	case class ViewerElement(viewer: AudioViewer, timeOffset: TimeSeconds)
}